'use strict';

var validate = require('@circlefin/validate');

/**
 * Map Yup validators to key/value format for localization.
 * - only needed for validators with values.
 */ validate.y.setLocale({
    string: {
        length: ({ length })=>({
                key: 'length',
                values: {
                    length
                }
            }),
        min: ({ min })=>({
                key: 'min',
                values: {
                    min
                }
            }),
        max: ({ max })=>({
                key: 'max',
                values: {
                    max
                }
            })
    }
});
//# sourceMappingURL=Form.Context.Locale.js.map
